module.exports = __webpack_public_path__ + "static/media/requestform.3e4c6abe.png";